import { loadTemplate } from '../template/index.js';
import { displayNotification, updateTabCounts, renderLoading, toggleSeeAllButton } from './render.js';
import { notificationStore } from './store.js';
import { fetchNotifications } from './ajax.js';
import { setupTabEvents, setupActionEvents } from './handlers.js';

let activeInstances = [];

/**
 * Initialize notification list
 */
export async function initNotificationList() {
	// Identify all notification list containers (Main page and/or Dropdown)
	const listContainers = document.querySelectorAll('.notification-list-target');
	if (!listContainers.length) return;

	// 1. Load templates
	await Promise.all([
		loadTemplate('notifications/item.ejs'),
		loadTemplate('notifications/empty.ejs'),
	]);

	// 2. Setup instances with their own state
	activeInstances = Array.from(listContainers).map(container => {
		const parent = container.closest('.notification-tab');
		const indicators = parent ? {
			all: parent.querySelector('[data-tab="all"] .indicator'),
			unread: parent.querySelector('[data-tab="unread"] .indicator')
		} : null;

		const instance = {
			container,
			indicators,
			parent,
			filter: 'all' // Independent filter for this instance
		};

		if (parent) {
			setupTabEvents(instance);
		}

		container.innerHTML = renderLoading();

		return instance;
	});

	// 3. Load notifications from CMS
	await loadNotificationsFromCMS();

	// 4. Setup Action Click Events (Delegated to each container)
	setupActionEvents(activeInstances);

	// 5. Initial Refresh
	refreshUI();

	// 6. Listen for real-time notifications
	window.addEventListener('fcm_message_received', async (event) => {
		// Reload from server and refresh UI
		await loadNotificationsFromCMS();
		refreshUI();

		const payload = event.detail;
		if (wpcore?.alert && payload.notification) {
			wpcore.alert('info', payload.notification.title, payload.notification.body);
		}
	});
}

/**
 * Load notifications from CMS
 */
async function loadNotificationsFromCMS() {
	const data = await fetchNotifications();
	notificationStore.setNotifications(data.notifications || []);
	notificationStore.setUserRole(data.user_role || 'end-user-client');
}

/**
 * Refresh UI for all instances using their own filters
 */
export function refreshUI() {
	activeInstances.forEach((instance) => {
		const { container, indicators, filter } = instance;
		const filteredData = notificationStore.getFilteredNotifications(filter);

		// Limit dropdown content to 3 items
		const isDropdown = container.closest('#notifi-dropdown');
		const dataToShow = isDropdown ? filteredData.slice(0, 3) : filteredData;

		displayNotification(container, dataToShow, filter, notificationStore.userRole);

		if (indicators) {
			updateTabCounts(indicators, notificationStore);
		}
	});

	// Toggle See All button based on total notification count (All tab)
	const totalCount = notificationStore.getCount('all');
	toggleSeeAllButton(totalCount);

	// Synchronize Global Badge
	updateNotificationBadge();
}

/**
 * Update the global notification badge (red circle with number)
 */
function updateNotificationBadge() {
	const badge = document.getElementById('notifi-count');
	if (!badge) return;

	const count = notificationStore.getCount('unread');
	if (count === 0) {
		badge.classList.add('hidden');
	} else {
		badge.classList.remove('hidden');
		badge.textContent = count > 99 ? '99+' : count;
	}
}
